import gql from 'graphql-tag';

const GET_AGENT_INSTALLER_DETAILS = gql`
  query(
    $siteId: ID!
    $installerType: Int
    $policyCategoryId: ID
    $departmentId: ID
  ) {
    getAgentInstallerDetails(
      siteId: $siteId
      installerType: $installerType
      policyCategoryId: $policyCategoryId
      departmentId: $departmentId
    ) {
      installerPackage {
        installerId
        installerName
        installerDownloadUrl
        os
        arch
      }
      silentInstaller {
        os
        arch
        scriptType
        command
      }
      bulkDeployment {
        gpo {
          os
          arch
          scriptType
          command
        }
        inTune {
          os
          arch
          scriptType
          command
        }
      }
    }
  }
`;

const GET_CLIENT_SITE_LIST = gql`
  query($input: ListInfoInput) {
    getClientSiteList(input: $input) {
      sites {
        id
        name
        businessHour {
          day
          start
          end
        }
        holidayList {
          id
          name
        }
        timezoneCode
        working24x7
        contactNumber
        account {
          accountId
          name
        }
        hq
        installerInfo {
          id
          installerName
          installerDownloadUrl
          os
          archPlaceholder
          installerCommandDetails
        }
        address {
          addressId
          line1
          line2
          line3
          city
          postalCode
          countryCode
          stateCode
        }
      }
    }
  }
`;
const GET_CLIENT_SITE_LIST_WITH_INSTALLER_INFO = gql`
  query($input: ListInfoInput!) {
    getClientSiteList(input: $input) {
      sites {
        id
        name
        account {
          accountId
          name
        }
        hq
        installerInfo {
          id
          installerName
          installerDownloadUrl
          os
          archPlaceholder
          installerCommandDetails
        }
      }
    }
  }
`;
const GET_CLIENT_SITE_LIST_FOR_DROPDOWN = gql`
  query($input: ListInfoInput) {
    getClientSiteList(input: $input) {
      sites {
        id
        name
        account {
          accountId
          name
        }
        hq
      }
    }
  }
`;

const GET_CLIENT_SITE_LIST_FOR_DROPDOWN_WO_ACCOUNT = gql`
  query($input: ListInfoInput) {
    getClientSiteList(input: $input) {
      sites {
        id
        name
        hq
      }
    }
  }
`;

const GET_SITE_QUERY = `id
      name
      businessHour {
        day
        start
        end
      }
      holidayList {
        id
        name
      }
      timezoneCode
      working24x7
      contactNumber
      account {
        accountId
        name
      }
      hq
      installerInfo {
       id
          installerName
          installerDownloadUrl
          os
          archPlaceholder
          installerCommandDetails
      }
      address {
        addressId
        line1
        line2
        line3
        city
        postalCode
        countryCode
        stateCode
      }`;
const GET_SITE = gql`
  query($input: SiteIdentifierInput!) {
    getClientSite(input: $input) {
      ${GET_SITE_QUERY}
    }
  }
`;

const CREATE_CLIENT_SITE = gql`
  mutation($input: CreateSiteInput!) {
    createClientSite(input: $input) {
      ${GET_SITE_QUERY}
    }
  }
`;

const UPDATE_SITE = gql`
  mutation($input: UpdateSiteInput!) {
    updateClientSite(input: $input) {
      id
      name
      businessHour {
        day
        start
        end
      }
      holidayList {
        id
        name
      }
      timezoneCode
      working24x7
      contactNumber
      account {
        accountId
        name
      }
      hq
      installerInfo {
        id
        installerName
        installerDownloadUrl
        os
        archPlaceholder
        installerCommandDetails
      }
      address {
        addressId
        line1
        line2
        line3
        city
        postalCode
        countryCode
        stateCode
      }
    }
  }
`;

const DELETE_CLIENT_SITE = gql`
  mutation($input: [SiteIdentifierInput!]!) {
    deleteClientSites(input: $input)
  }
`;

const DELETE_CLIENT_SITE_V2 = gql`
  mutation($input: DeleteClientSitesInput!) {
    deleteClientSitesV2(input: $input)
  }
`;
export {
  CREATE_CLIENT_SITE,
  UPDATE_SITE,
  GET_SITE,
  DELETE_CLIENT_SITE,
  DELETE_CLIENT_SITE_V2,
  GET_AGENT_INSTALLER_DETAILS,
  GET_CLIENT_SITE_LIST,
  GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
  GET_CLIENT_SITE_LIST_FOR_DROPDOWN_WO_ACCOUNT,
  GET_CLIENT_SITE_LIST_WITH_INSTALLER_INFO
};
